import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_DELETE_ACCOUNT_DATA_BEGIN,
  MANAGE_SUBS_DELETE_ACCOUNT_DATA_SUCCESS,
  MANAGE_SUBS_DELETE_ACCOUNT_DATA_FAILURE,
  MANAGE_SUBS_DELETE_ACCOUNT_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function deleteAccountData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_DELETE_ACCOUNT_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
     
      const doRequest = axios.delete(`${API_REQUEST_URL}/deleteManageAccountsData`, {
        headers: {
          'Authorization': token,
        },
        data: args,
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_DELETE_ACCOUNT_DATA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_DELETE_ACCOUNT_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteAccountDataError() {
  return {
    type: MANAGE_SUBS_DELETE_ACCOUNT_DATA_DISMISS_ERROR,
  };
}

export function useDeleteAccountData() {
  const dispatch = useDispatch();

  const { deleteAccountDataPending, deleteAccountDataError } = useSelector(
    state => ({
      deleteAccountDataPending: state.manageSubs.deleteAccountDataPending,
      deleteAccountDataError: state.manageSubs.deleteAccountDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(deleteAccountData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDeleteAccountDataError());
  }, [dispatch]);

  return {
    deleteAccountData: boundAction,
    deleteAccountDataPending,
    deleteAccountDataError,
    dismissDeleteAccountDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_DELETE_ACCOUNT_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteAccountDataPending: true,
        deleteAccountDataError: null,
      };

    case MANAGE_SUBS_DELETE_ACCOUNT_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteAccountDataPending: false,
        deleteAccountDataError: null,
      };

    case MANAGE_SUBS_DELETE_ACCOUNT_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteAccountDataPending: false,
        deleteAccountDataError: action.data.error,
      };

    case MANAGE_SUBS_DELETE_ACCOUNT_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteAccountDataError: null,
      };

    default:
      return state;
  }
}
